import {
  BarChartOutlined,
  DownloadOutlined,
  FileSearchOutlined,
  HistoryOutlined,
  MessageOutlined,
  RobotOutlined,
  SafetyCertificateOutlined,
  SettingOutlined,
  TeamOutlined,
  ThunderboltOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import type { ComponentType } from "react";

/**
 * Иконка и цвет раздела — в одном месте.
 *
 * По этим значениям красятся три разные вещи: пункт меню в сайдбаре, кружок с
 * иконкой в шапке страницы и плитки на сводке. Когда они жили инлайном на
 * страницах, «Пополнения» успели побывать и золотыми, и синими одновременно.
 *
 * Цвета — сырые hex, а не токены темы: это опознавательный знак раздела, он
 * обязан быть одинаковым в светлой и тёмной теме, иначе меню «мигает» при
 * переключении. Подложка под иконку строится из того же цвета прозрачностью,
 * поэтому контраст держится в обеих темах.
 */
export interface Section {
  color: string;
  Icon: ComponentType<{ className?: string; style?: React.CSSProperties }>;
}

export const SECTIONS = {
  dashboard: { color: "#1677ff", Icon: BarChartOutlined },
  deposits: { color: "#f59e0b", Icon: DownloadOutlined },
  withdrawals: { color: "#06b6d4", Icon: UploadOutlined },
  users: { color: "#8b5cf6", Icon: TeamOutlined },
  // Розовый — единственный свободный тон палитры: модерация должна
  // отличаться от заявок (золото, бирюза) и от пользователей (фиолет).
  comments: { color: "#ec4899", Icon: MessageOutlined },
  audit: { color: "#64748b", Icon: FileSearchOutlined },
  robots: { color: "#10b981", Icon: RobotOutlined },
  accruals: { color: "#f43f5e", Icon: ThunderboltOutlined },
  settings: { color: "#0ea5e9", Icon: SettingOutlined },
  admins: { color: "#a855f7", Icon: SafetyCertificateOutlined },
  history: { color: "#64748b", Icon: HistoryOutlined },
} as const satisfies Record<string, Section>;

export type SectionKey = keyof typeof SECTIONS;

/**
 * Подложка под иконку: тот же цвет, но прозрачностью.
 *
 * `color-mix` вместо готового hex: значение должно оставаться читаемым и на
 * белой карточке, и на тёмной, а два набора констант на каждый раздел
 * разъезжаются при первой же правке палитры.
 */
export function sectionSurface(color: string, alpha = 0.14): string {
  return `color-mix(in srgb, ${color} ${String(Math.round(alpha * 100))}%, transparent)`;
}
